<template>
    <panel-competition-form-box class="mab8 register-input-item">
        <div class="col-12">
            <div class="register-item">
                <div class="register-item__content">
                    <div class="register-item__top">
                        <div class="register-item__main">
                            <div v-if="showsName" class="mab16">
                                <base-input-text
                                    :value="value.fNamePl"
                                    hint="Pytanie"
                                    without-error-message
                                    is-short
                                    @input="patch({ fNamePl: $event })"
                                />
                            </div>

                            <div v-if="value.fType === 'fi'" class="mab24 register-item__preview">Krótka odpowiedź</div>
                            <div v-else-if="value.fType === 'fj'" class="mab24">
                                <base-input-text
                                    :value="value.hint"
                                    hint="Podpowiedź"
                                    without-error-message
                                    is-short
                                    @input="patch({ hint: $event })"
                                />
                            </div>
                            <div
                                v-else-if="value.fType === 'fl'"
                                class="mab24 register-item__preview register-item__preview--tall"
                            >
                                Długa odpowiedź
                            </div>
                            <div v-else-if="value.fType === 'fr'" class="mab24">
                                <div
                                    v-for="(option, optionIndex) in value.options"
                                    :key="`radio-${value._key}-${optionIndex}`"
                                    class="register-item__option mab8"
                                >
                                    <span class="register-item__option-mark">
                                        <i class="far fa-circle" />
                                    </span>
                                    <base-input-text
                                        class="register-item__option-field"
                                        :value="option"
                                        hint="Odpowiedź"
                                        without-error-message
                                        is-short
                                        @input="updateOption(optionIndex, $event)"
                                    />
                                    <base-button
                                        v-if="value.options.length > 1"
                                        btn2
                                        short
                                        icon="fas fa-trash"
                                        @click="removeOption(optionIndex)"
                                    />
                                </div>
                                <base-button btn2 short class="mat8" @click="addOption">Dodaj odpowiedź</base-button>
                            </div>
                            <div v-else-if="value.fType === 'fs'" class="mab24">
                                <div
                                    v-for="(option, optionIndex) in value.options"
                                    :key="`option-${value._key}-${optionIndex}`"
                                    class="register-item__option mab8"
                                >
                                    <span class="register-item__option-mark">
                                        <i class="fas fa-caret-down" />
                                    </span>
                                    <base-input-text
                                        class="register-item__option-field"
                                        :value="option"
                                        hint="Odpowiedź"
                                        without-error-message
                                        is-short
                                        @input="updateOption(optionIndex, $event)"
                                    />
                                    <base-button
                                        v-if="value.options.length > 1"
                                        btn2
                                        short
                                        icon="fas fa-trash"
                                        @click="removeOption(optionIndex)"
                                    />
                                </div>
                                <base-button btn2 short class="mat8" @click="addOption">Dodaj odpowiedź</base-button>
                            </div>
                            <div v-else-if="value.fType === 'fc'" class="register-item__option mab24">
                                <span class="register-item__option-mark">
                                    <input type="checkbox" disabled />
                                </span>
                                <base-input-text
                                    class="register-item__option-field"
                                    :value="value.confirmation"
                                    hint="Potwierdzenie"
                                    without-error-message
                                    is-short
                                    @input="patch({ confirmation: $event })"
                                />
                            </div>
                            <div v-else-if="value.fType === 'fh'" class="mab24 register-item__preview">Godzina</div>
                            <div v-else-if="value.fType === 'fd'" class="mab24 register-item__preview">Data</div>
                            <div v-else-if="value.fType === 'fa'" class="mab24 register-item__preview">
                                Paczkomat Inpost
                            </div>
                        </div>

                        <div class="register-item__side">
                            <div class="mab16">
                                <div class="register-item__select">
                                    <v-select
                                        :value="value.fType"
                                        :options="typeOptions"
                                        :reduce="(item) => item.id"
                                        :clearable="false"
                                        :searchable="false"
                                        label="text"
                                        @input="onTypeChange"
                                    >
                                        <template slot="option" slot-scope="option">
                                            <i :class="option.icon" class="register-item__type-icon" />
                                            <span>{{ option.text }}</span>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <i :class="option.icon" class="register-item__type-icon" />
                                            <span>{{ option.text }}</span>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                            <div v-if="showsValidation" class="mab16">
                                <base-input-select
                                    :value="value.fValidation"
                                    :options="validationOptions"
                                    :reduce="(item) => item.id"
                                    :searchable="false"
                                    :clearable="false"
                                    is-panel
                                    without-error-message
                                    @input="patch({ fValidation: $event })"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="register-item__footer">
                        <div class="register-item__main register-item__main--actions">
                            <label class="register-item__required">
                                <input
                                    type="checkbox"
                                    :checked="value.fRequired"
                                    @change="patch({ fRequired: $event.target.checked })"
                                />
                                Wymagana odpowiedź
                            </label>
                        <base-button btn2 short icon="fas fa-trash" @click="$emit('remove', index)">
                            Usuń
                        </base-button>
                        <base-button btn2 short icon="fas fa-clone" @click="$emit('copy', index)">
                            Powiel
                        </base-button>
                        </div>
                        <div class="register-item__side">
                            <div class="register-item__classifications">
                                <multiselect
                                    :value="selectedClassifications"
                                    :options="classifications"
                                    label="namePl"
                                    track-by="id"
                                    :multiple="true"
                                    :searchable="false"
                                    :close-on-select="false"
                                    :show-labels="false"
                                    :hide-selected="false"
                                    placeholder="Pytanie widoczne dla..."
                                    @input="onClassificationsChange"
                                >
                                    <template slot="tag" slot-scope="{ option }">
                                        <span class="custom__tag">{{ option.namePl }},&nbsp;</span>
                                    </template>
                                    <template slot="caret">
                                        <span v-if="selectedClassifications.length > 0" class="caret-count">
                                            {{ selectedClassifications.length }}
                                        </span>
                                        <div v-else class="multiselect__select" />
                                    </template>
                                </multiselect>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="register-item__reorder">
                    <button
                        type="button"
                        class="register-item__reorder-btn"
                        :disabled="index === 0"
                        title="W górę"
                        @click="$emit('move-up', index)"
                    >
                        <i class="fas fa-angle-double-up" />
                    </button>
                    <button
                        type="button"
                        class="register-item__reorder-btn"
                        :disabled="index >= total - 1"
                        title="W dół"
                        @click="$emit('move-down', index)"
                    >
                        <i class="fas fa-angle-double-down" />
                    </button>
                </div>
            </div>
        </div>
    </panel-competition-form-box>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import VSelect from 'vue-select';
    import PanelCompetitionFormBox from '@/components/PanelCompetitionFormBox';
    import { INPUT_TYPE_OPTIONS, VALIDATION_OPTIONS } from '@/constants/competitionRegisterInputs';

    function sameIdSet(a, b) {
        if (a.length !== b.length) {
            return false;
        }
        const left = [...a].sort((x, y) => x - y);
        const right = [...b].sort((x, y) => x - y);
        return left.every((id, i) => id === right[i]);
    }

    export default {
        name: 'PanelCompetitionRegisterInputItem',
        components: {
            Multiselect,
            VSelect,
            PanelCompetitionFormBox,
        },
        props: {
            value: {
                type: Object,
                required: true,
            },
            index: {
                type: Number,
                required: true,
            },
            total: {
                type: Number,
                required: true,
            },
            classifications: {
                type: Array,
                default: () => [],
            },
            typeOptions: {
                type: Array,
                default: () => INPUT_TYPE_OPTIONS,
            },
            validationOptions: {
                type: Array,
                default: () => VALIDATION_OPTIONS,
            },
        },
        computed: {
            showsName() {
                return this.value.fType !== 'fc';
            },
            showsValidation() {
                return this.value.fType === 'fi' || this.value.fType === 'fl';
            },
            selectedClassifications() {
                const ids = (this.value.classificationIds || []).map((id) => Number(id));
                return this.classifications.filter((item) => ids.includes(Number(item.id)));
            },
        },
        methods: {
            patch(partial) {
                this.$emit('input', { ...this.value, ...partial });
            },
            onTypeChange(fType) {
                const next = { fType };
                if (fType !== 'fi' && fType !== 'fl') {
                    next.fValidation = '';
                }
                if (fType === 'fr' || fType === 'fs') {
                    if (!this.value.options || this.value.options.length < 2) {
                        next.options = ['', ''];
                    }
                }
                if (fType === 'fj' && this.value.hint == null) {
                    next.hint = '';
                }
                if (fType === 'fc' && this.value.confirmation == null) {
                    next.confirmation = '';
                }
                this.patch(next);
            },
            onClassificationsChange(selected) {
                const list = Array.isArray(selected) ? selected : [];
                const ids = list.map((item) => item.id);
                if (sameIdSet(ids, this.value.classificationIds || [])) {
                    return;
                }
                this.patch({ classificationIds: ids });
            },
            updateOption(optionIndex, text) {
                const options = [...this.value.options];
                options[optionIndex] = text;
                this.patch({ options });
            },
            addOption() {
                this.patch({ options: [...(this.value.options || []), ''] });
            },
            removeOption(optionIndex) {
                const options = this.value.options.filter((_, i) => i !== optionIndex);
                this.patch({ options: options.length ? options : [''] });
            },
        },
    };
</script>

<style src="vue-select/dist/vue-select.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
    .register-item {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        width: 100%;
    }

    .register-item__content {
        flex: 1 1 auto;
        min-width: 0;
    }
    .register-item__top {
        display: flex;
        flex-wrap: wrap;
        gap: 16px 24px;
        width: 100%;
    }
    .register-item__main {
        flex: 1 1 280px;
        min-width: 0;
    }
    .register-item__side {
        flex: 0 1 240px;
        min-width: 0;
    }
    .register-item__preview {
        min-height: 40px;
        line-height: 40px;
        padding: 0 16px;
        border: 1px solid var(--color-bluish-grey, #cfd8dc);
    }
    .register-item__preview--tall {
        min-height: 80px;
        /* line-height: 80px; */
    }
    .register-item__option {
        display: flex;
        align-items: center;
        gap: 8px;
        width: 100%;
    }
    .register-item__option-mark {
        flex: 0 0 auto;
        width: 24px;
        text-align: center;
        color: var(--color-white, #fff);
    }
    .register-item__option-field {
        flex: 1 1 auto;
        min-width: 0;
    }
    .register-item__select {
        height: 40px;
        border: solid 1px var(--color-slate-two);
        border-radius: 4px;
        background-color: var(--color-white);
        box-sizing: border-box;
        padding: 0 8px;
    }
    .register-item__select >>> .vs__dropdown-toggle {
        border: none;
        padding: 0;
        height: 38px;
    }
    .register-item__select >>> .vs__selected {
        margin: 0;
        padding: 0;
        display: flex;
        align-items: center;
    }
    .register-item__select >>> .vs__search {
        margin: 0;
    }
    .register-item__type-icon {
        margin-right: 8px;
        width: 16px;
        text-align: center;
    }
    .register-item__footer {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 8px 12px;
        margin-top: 8px;
        width: 100%;
    }
    .register-item__main--actions {
        display: flex;
        gap: 8px;
        margin-right: 8px;
    }
    .register-item__main--actions >>> .btn:first-of-type {
        margin-left: auto;
    }

    .register-item__required {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
        margin: 0;
        font-weight: 400;
        flex: 0 0 auto;
    }
    .register-item__required input {
        margin: 0;
    }
    .register-item__classifications {
        flex: 1 1 220px;
        min-width: 180px;
    }
    .register-item__reorder {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex: 0 0 auto;
        padding-top: 8px;
    }
    .register-item__reorder-btn {
        background: transparent;
        border: none;
        color: var(--color-silver, #90a4ae);
        cursor: pointer;
        padding: 2px 6px;
        line-height: 1;
    }
    .register-item__reorder-btn:disabled {
        opacity: 0.3;
        cursor: default;
    }
    .caret-count {
        position: absolute;
        width: 26px;
        height: 26px;
        top: 7px;
        right: 10px;
        border-radius: 50%;
        background: var(--color-dark-pastel-green, #50ae55);
        color: var(--color-white, #fff);
        font-size: 12px;
        line-height: 26px;
        text-align: center;
        z-index: 2;
    }
    .custom__tag {
        display: inline;
    }
    @media (min-width: 992px) {
        .register-item__main {
            flex: 2 1 0;
        }
        .register-item__side {
            flex: 1 1 0;
            max-width: 320px;
        }
    }
</style>
